export var SituationReason;
(function (SituationReason) {
    SituationReason["RESPONSE_OPINION"] = "RESPONSE_OPINION";
    SituationReason["REQUEST_OPINION"] = "REQUEST_OPINION";
    SituationReason["OPINION"] = "OPINION";
    SituationReason["URGENT"] = "URGENT";
})(SituationReason || (SituationReason = {}));
export var Situation;
(function (Situation) {
    Situation["APPROVED"] = "APPROVED";
    Situation["PENDING"] = "PENDING";
    Situation["FORWARDED"] = "FORWARDED";
    Situation["DISAPPROVED"] = "DISAPPROVED";
    Situation["CLOSED"] = "CLOSED";
    Situation["OPINION"] = "OPINION";
})(Situation || (Situation = {}));
//# sourceMappingURL=approval-list-card-types.js.map